import React, { Component} from 'react'
import { observer } from 'mobx-react'
import Store from '../store/ProductionTableStore'
import TableHeader from '../partials/table/TableHeader'
import TableBody from '../partials/table/TableBody'
import TableFooter from '../partials/table/TableFooter'

@observer
class LateOrders extends Component {
    render() {  
        let orders = []
        let header = null
        let footer = null
        const lateOrders = Store.ordersByDate.late_orders

        if (lateOrders && lateOrders.orders.length > 0) {
            header = <TableHeader
                title={ 'Försenat' }
                day={ lateOrders }
            />

            footer = <TableFooter day={ lateOrders } />
            
            lateOrders.orders.forEach((order, key) => {
                orders.push(<TableBody
                    key={ `table-body-${ key }` }
                    date={ 'late_orders' }
                    order={ order }
                    orderPosition={ key }
                />)
            })
        }

        return <div className="table">
            { header }            
            
            <div className={ `table__wrap ${ lateOrders && lateOrders.openDayBar ? 'table__wrap--open' : '' }` }>
                { orders }
            </div>

            { footer }
        </div>
    }
}

export default LateOrders
